import {createAsyncThunk} from "@reduxjs/toolkit";
import axios from "axios";
import {USER_LOCALSTORAGE_KEY} from "../../../../../../shared/const/localstorage";
import {
    setResponseSubscribedLessonId
} from "../../../../slice/lessons/lessons-demo/setLessonsDemo";


export const singUpMeeting = createAsyncThunk(
    "lessons/singUpMeeting",
    async (lessonsId: number, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error("No token found in localStorage.");
            }
            const {token} = JSON.parse(authToken);

            const response = await axios.post(`/api/lessons/${lessonsId}/sign-up`,
                null,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            thunkAPI.dispatch(setResponseSubscribedLessonId(response.data.subscribedLessonId))


            return response.data;

        } catch (error) {
            console.error("Произошла ошибка:", error);
            return thunkAPI.rejectWithValue("error");
        }
    }
);
